"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../utils/utils");
var load_more_1 = require("../features/load-more");
function init() {
    init_load_more();
    init_form();
}
exports.init = init;
function init_load_more() {
    var seconds_in_a_day = 60 + 60 * 24;
    var laboratory_materials_container = document.getElementById('laboratory-materials-container');
    if (laboratory_materials_container) {
        var params = {
            // parameter
            date_from: 0,
            date_to: 0,
            first_letter: ""
        };
        (0, load_more_1.initialize_load_more)('laboratory-materials', params).catch(function (e) { return console.error(e); });
    }
}
function init_form() {
    var form = (0, utils_1.get_element_by_id_or_null)('materials-form', HTMLFormElement);
    if (!form)
        return;
    var submit = (0, utils_1.get_element_by_id_or_fail)('request-materials', HTMLButtonElement);
    //
    form.addEventListener("submit", function (event) {
        event.preventDefault();
        var inputs = form.querySelectorAll('input,select');
        var form_data = [];
        for (var i = 0; i < inputs.length; ++i) {
            var input = inputs.item(i);
            if (!(input instanceof HTMLInputElement)
                && !(input instanceof HTMLSelectElement)) {
                continue;
            }
            if (!input.value || input.value === "0")
                continue;
            form_data.push([input.name, input.value]);
        }
        var request_data = new URLSearchParams(form_data);
        fetch("/orders", {
            method: "post",
            body: request_data,
        })
            .then(utils_1.handle_fetch_json_response)
            .then(function (response) {
            for (var i = 0; i < inputs.length; ++i) {
                var input = inputs.item(i);
                if (!(input instanceof HTMLInputElement)
                    && !(input instanceof HTMLSelectElement)) {
                    continue;
                }
                input.value = "0";
            }
            // success popup
            var popup = window.popups.get('message-success');
            if (popup)
                popup.open();
        })
            .catch(function (e) {
            console.error(e);
            var popup = window.popups.get('message-fail');
            if (popup)
                popup.open();
        });
        return false;
    });
}
